import { Box } from '@mui/material';
import {
  VideoGrid,
  useRemoteVideoTileState,
  useRosterState,
} from 'amazon-chime-sdk-component-library-react';
import styled from 'styled-components';

import LocalUserVideo from './localUserVideo';
import UserVideo from './userVideo';

import { useMeetingContext } from '../../contexts/meeting/meetingContext';

const StyledVideoGrid = styled(VideoGrid)`
  background: none;
  gap: 1rem;
`;

function UserVideoTileGrid() {
  const { attendeeIdToTileId } = useRemoteVideoTileState();
  const { attendeeID: localAttendeeID } = useMeetingContext();
  const { roster: allRoster } = useRosterState();
  const rosters = Object.values(allRoster);
  const remoteRosters = rosters.filter(
    (roster) =>
      roster.chimeAttendeeId !== localAttendeeID &&
      !roster.externalUserId?.startsWith('aws:MediaPipeline'),
  );

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        padding: '1rem',
      }}
    >
      {/* +1 for local user video */}
      <StyledVideoGrid size={remoteRosters.length + 1}>
        <LocalUserVideo
          name={
            rosters.find((roster) => roster.chimeAttendeeId === localAttendeeID)
              ?.name ?? 'Anonymous'
          }
          attendeeID={localAttendeeID}
        />
        {remoteRosters.map((roster) => {
          return (
            <UserVideo
              key={roster.chimeAttendeeId}
              tileID={attendeeIdToTileId[roster.chimeAttendeeId]}
              name={roster.name}
              attendeeID={roster.chimeAttendeeId}
            />
          );
        })}
      </StyledVideoGrid>
    </Box>
  );
}

export default UserVideoTileGrid;
